<template>
    <el-dialog
        :visible.sync="show"
        title="用户中心"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        fullscreen
        append-to-body
        custom-class="user-center-dialog"
        :before-close="close"
    >
        <iframe v-if="url" :src="url" frameborder="0"></iframe>
    </el-dialog>
</template>

<script>
import {mapGetters} from 'vuex';
import {getAutologinandredirectUrl, getRedirectUrl} from '@/util/util';

export default {
    name: 'UserCenterDialogIframe',
    data() {
        return {
            show: true,
            url: ''
        };
    },
    computed: {
        ...mapGetters(['userInfo', 'platform'])
    },
    mounted() {
        let redirecturl = getRedirectUrl(window.Config.userCenterUrl, {
            userguid: this.userInfo.userguid,
            platform: this.platform,
            prefectureguid: window.Config.prefectureguid,
            applicationguid: window.Config.prefectureguid
        });
        this.url = getAutologinandredirectUrl({
            userguid: this.userInfo.userguid,
            redirecturl
        });
    },
    beforeDestroy() {
    },
    methods: {
        close() {
            this.$emit('close');
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep {
    .user-center-dialog {
        .el-dialog__body {
            padding: 0;

            iframe {
                width: 100%;
                height: 100%;
                border: none;
            }
        }
    }
}
</style>
